import angelikaPhoto from "@/assets/angelika-wielgus-lach.jpg.asset.json";
import hannaPhoto from "@/assets/hanna-gruzdowska.jpg.asset.json";
import ewelinaPhoto from "@/assets/ewelina-sasin.jpg.asset.json";
import listEwelina from "@/assets/list-referencyjny-ewelina-sasin.pdf.asset.json";

export const speakingTopics = [
  {
    title: "Samotność lidera",
    description:
      "O blaskach i cieniach sukcesu, który widzą wszyscy, i ciężarze, który znasz tylko Ty.",
  },
  {
    title: "Dlaczego najlepsi wypalają się pierwsi",
    description:
      "Dlaczego wypalenie najczęściej dotyka najbardziej zaangażowanych i co organizacja może zrobić, zanim ich straci.",
    link: {
      anchor: "wypalenie najczęściej dotyka najbardziej zaangażowanych",
      to: "/wypalenie-zawodowe-u-lidera",
    },
  },
  {
    title: "Zmęczony lider to zmęczony biznes",
    description:
      "Jak stan osoby zarządzającej przekłada się na decyzje, zespół i wyniki firmy, i jak temu zapobiec.",
    link: {
      anchor: "stan osoby zarządzającej przekłada się na decyzje",
      to: "/stres-w-pracy-a-decyzje",
    },
  },
  {
    title: "Jak budować firmę, nie zużywając siebie",
    description:
      "O tym, jak rozwijać organizację bez płacenia za to zdrowiem, relacjami i sobą.",
  },
] as const;

export type SpeakerTestimonial = {
  name: string;
  role: string;
  photo?: string;
  initials?: string;
  quote: string;
  rest: string[];
  /** Gdy ustawione, po rozwinięciu zastępuje zajawkę pełną treścią (bez powtórzeń). */
  fullText?: string[];
  pdf?: { url: string; label: string };
  /** Skan listu pokazywany po rozwinięciu, bo PDF zasobów pobiera się zamiast wyświetlać. */
  image?: { url: string; alt: string };
  highlights?: string[];
};

export const speakerTestimonials: SpeakerTestimonial[] = [
  {
    photo: ewelinaPhoto.url,
    initials: "ES",
    name: "Ewelina Sasin",
    role: "CEO agencji Ewesa, organizatorka festiwalu Longevity Week (Gdańsk, 2026)",
    highlights: ["Longevity Week"],
    quote:
      "To, co wyjątkowo zachwyciło nas i naszą publiczność, to jej niezwykła umiejętność przełożenia skomplikowanej, opartej na dowodach naukowych wiedzy na przystępny, angażujący i pełen empatii język.",
    rest: [],
    // Pełna treść listu referencyjnego, słowo w słowo ze skanu PDF.
    fullText: [
      "Z ogromną przyjemnością udzielam referencji Sylwii Sitkowskiej, która uświetniła swoją obecnością pierwszą edycję festiwalu Longevity Week 2026 w Gdańsku, występując w roli Prelegentki na naszej scenie eksperckiej.",
      "Wystąpienie Sylwii dnia 19.09.2026 zatytułowane „Długowieczność to nie tylko biologia. Czego o starzeniu uczy nas psychologia?” dostarczyło naszym słuchaczom niezwykle cennej perspektywy i ważnych informacji o tym, jak dbanie o zdrowie psychiczne pozytywnie wpływa na naszą długowieczność. Jej prelekcja zgromadziła pełną salę, a sposób, w jaki dzieliła się swoją wiedzą, spotkał się z bardzo dobrym odbiorem naszej wymagającej i świadomej publiczności. Z naszych ankiet dla uczestników wynika, że obszar układu nerwowego i zarządzania stresem to obecnie największe wyzwanie zdrowotne dla uczestników, a Sylwia zaadresowała te potrzeby w sposób mistrzowski.",
      "To, co wyjątkowo zachwyciło nas i naszą publiczność, to jej niezwykła umiejętność przełożenia skomplikowanej, opartej na dowodach naukowych wiedzy na przystępny, angażujący i pełen empatii język. Sylwia nawiązała fantastyczny kontakt z salą, tworząc przestrzeń pełną zaufania, co zaowocowało pytaniami i inspirującymi dyskusjami w kuluarach także po zakończeniu jej wystąpienia.",
      "Oprócz merytoryki i charyzmy na najwyższym poziomie, współpraca z Sylwią od strony organizacyjnej była czystą przyjemnością. To profesjonalistka w każdym calu – zaangażowana, komunikatywna i emanująca wspaniałą energią, która idealnie wpisała się w ideę naszego wydarzenia.",
      "Gorąco polecam współpracę z Sylwią Sitkowską każdej organizacji poszukującej wybitnego, charyzmatycznego eksperta i prelegenta. Jej obecność na scenie to gwarancja najwyższej jakości merytorycznej oraz ogromnej wartości dla uczestników.",
    ],
    pdf: { url: listEwelina.url, label: "Pobierz list referencyjny (PDF)" },
    image: {
      url: "/images/list-referencyjny-ewelina-sasin.jpg",
      alt: "Skan listu referencyjnego od Eweliny Sasin, CEO agencji Ewesa",
    },
  },
  {
    photo: hannaPhoto.url,
    name: "Hanna Gruzdowska",
    // Podpis skrócony na prośbę Sylwii (2026-10-21): usunięty fragment o roli analityka i psycholożki organizacji.
    role: "Założycielka analiza IT oraz P2B, organizatorka Konferencja Analiza IT",
    highlights: ["Konferencji Analiza IT", "Konferencja Analiza IT", "analiza IT", "konferencji dla analityków biznesowych w branży IT"],
    quote:
      "Serdecznie polecam współpracę z Panią Sylwią. Miałyśmy okazję współpracować przy konferencji dla analityków biznesowych w branży IT - grupy wymagającej i mocno skoncentrowanej na kompetencjach, wynikach i technologii.",
    rest: [
      "Pani Sylwia bardzo szybko weszła w dość niszowy temat i świetnie odnalazła się w specyfice pracy analityków. Jej wystąpienie przypadło na szczególny moment konferencji - uczestnicy wcześniej otrzymali trudny feedback dotyczący współpracy z innymi rolami. Pani Sylwia pomogła im spojrzeć na ten feedback z zupełnie innej perspektywy, lepiej zrozumieć źródła trudności, ale też dostrzec własne mocne strony i obszary, o które warto zadbać, aby nie doprowadzić do przeciążenia i wypalenia.",
    ],
  },
  {
    photo: angelikaPhoto.url,
    name: "Angelika Wielgus-Lach",
    role: "organizatorka konferencji „Diamenty Europy”",
    highlights: ["„Diamenty Europy”"],
    quote:
      "Kompetentna, przekazująca w angażujący i bardzo przystępny sposób merytoryczne treści, tak w dużym skrócie mogłabym opisać Sylwię.",
    rest: [
      "Bardzo serdecznie polecam współpracę z nią. Jest bardzo ciepłą osobą i bardzo dobrze przygotowaną do tego, co ma mówić. Była jedną z prelegentek na mojej konferencji biznesowej „Diamenty Europy” i zebrała bardzo dużo pozytywnych opinii.",
    ],
  },
];